/**
 * 施設タイプ
 */
export default class PlaceType {
  /**
   *
   * @param {Array} placeTypes
   * @param {Object=} options
   */
  constructor(placeTypes, options) {
    this.reset(placeTypes, options);
  }
  /**
   *
   * @param type_id
   * @returns {*}
   */
  getTypeIcon(type_id){
    if (this.placeTypes[type_id] && this.placeTypes[type_id].icon_min){
      return this.icon_file_path + this.placeTypes[type_id].icon_min;
    }
    if (this.placeTypes[type_id] && this.placeTypes[type_id].icon_pin){
      return this.icon_file_path + this.placeTypes[type_id].icon_pin;
    }
    return this.icon_default;
  }
  /**
   *
   * @param type_id
   * @returns {*}
   */
  getMarkerIcon(type_id){
    if (this.placeTypes[type_id] && this.placeTypes[type_id].icon_pin){
      return this.icon_file_path + this.placeTypes[type_id].icon_pin;
    }
    return this.icon_default;
  }
  getName(type_id) {
    return this.facility_type_name_table[type_id];
  }
  getAll() {
    return this.placeTypes;
  }
  /**
   * 外から設定し直したい場合
   * 
   */
  reset(placeTypes, options) {
    this.placeTypes = placeTypes;
    this.icon_default = options.icon_default;
    this.icon_file_path = options.icon_file_path;

    this.facility_type_name_table = [];
    for (var i = 0; i < placeTypes.length; i++) {
      var place = placeTypes[i];
      this.facility_type_name_table.push(place.name);
    }
  }
}




// WEBPACK FOOTER //
// ./map/js/ih/PlaceType.js